import { render, staticRenderFns } from "./RepairDetailsView.vue?vue&type=template&id=17f50cb0"
import script from "./RepairDetailsView.vue?vue&type=script&lang=js"
export * from "./RepairDetailsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports